import { post, get, patch } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ISectionSlider } from "../types/sectionslider";

export const useFetchSlider = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        const response = await get("sectionSlider/list?sliderCategoryType=" + data.sliderCategoryType);
        return response.data;
    }, options);
};

export const useAddSlider = (options?: UseMutationOptions<any, any, ISectionSlider, any>) => {
     return useMutation(async (data: any) => {
        const formatteddata = {
                sliderID: data.sliderID ?? "00000000-0000-0000-0000-000000000000",
                title: data.title,
                propertyPlaceID:data.propertyPlaceID,
                sliderCategoryTypeID : data.sliderCategoryTypeID,
                isActive: data.isActive
        }
        return await post("sectionSlider", formatteddata);
    }, options);
};

export const useDeleteSlider = (options: any) => {
    return useMutation(async (sliderID) => {
        const response = await patch(`sectionSlider/${sliderID}/delete`, {});
        return response.data;
    }, options);
};

export const useFetchAccommodationType = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        const response = await get("sectionSlider/accommodation-list");
        return response.data;
    }, options);
};

export const useUpdateStatusSlider = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data:any) => {
        const response = await patch(`sectionSlider/${data.sliderID}/${data.isActive}/update-status`, {});
        return response.data;
    }, options);
};